import React, { type FC } from 'react';

import { LoadableAfterPaint } from '@confluence/loadable';

import { BreadcrumbsPlaceholder } from '../src/BreadcrumbsPlaceholder.tsx';
import { Breadcrumbs as BreadcrumbsComponent, type BreadcrumbsProps } from '../src/Breadcrumbs.tsx';

export { FixedSpaceHeaderContainer, FixedSpaceHeaderWithBannerContainer } from '../src/Breadcrumbs.tsx';

export const BreadcrumbsLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Breadcrumbs" */ '../src/Breadcrumbs.tsx')).Breadcrumbs,
	loading: BreadcrumbsPlaceholder,
});
export const Breadcrumbs: FC<BreadcrumbsProps> = (props) => <BreadcrumbsLoader {...props} />;

export const BreadcrumbsNonLoadable: FC<BreadcrumbsProps> = (props) => (
	<BreadcrumbsComponent {...props} />
);

export const FixedBreadcrumbsNavForPageLayoutLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Breadcrumbs" */ '../src/Breadcrumbs.tsx'))
			.FixedBreadcrumbsNavForPageLayout,
});
